import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Header from '@/components/site/Header';
import Footer from '@/components/site/Footer';
import ApplicationDialog from '@/components/site/ApplicationDialog';

export default function LegalLayout() {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  // ensure clicking nav scrolls take user back to landing with hash
  React.useEffect(() => {
    const handler = (e) => {
      const id = e.detail;
      if (id) navigate(`/#${id}`);
    };
    window.addEventListener('legal-nav-to', handler);
    return () => window.removeEventListener('legal-nav-to', handler);
  }, [navigate]);

  return (
    <div className="bg-white min-h-screen flex flex-col">
      <Header onApply={() => setOpen(true)} />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer onApply={() => setOpen(true)} />
      <ApplicationDialog open={open} onOpenChange={setOpen} />
    </div>
  );
}
